import React, { Component } from 'react';

import HelpfulInfoChildPageBase from '../HelpfulInfo/HelpfulInfoChildPageBase';

interface OwnProps {}
interface OwnState {}

class PrivacyPolicy extends Component<OwnProps, OwnState> {
  render() {
    return <HelpfulInfoChildPageBase pageID={1323} />;
  }
}
export default PrivacyPolicy;
